import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ServiceNowTicket } from 'src/app/models/servicenowticket.model';

@Injectable({
  providedIn: 'root',
})
export class ServiceNowService {
  constructor(private http: HttpClient) {}

  createTicket(fields: ServiceNowTicket) {
    return this.http.post(
      environment.apiUrl + '/support/createticket/',
      fields
    );
  }
}
